import { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '~/commonComponents';
import { ShiftRequestRedesign } from '~/constants/ff.posthog';
import { useFeatureFlagVariant } from '~/hooks/useFeatureFlagVariant';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';
import { POSTHOG_EVENTS, trackPosthogEvent } from '~/services/posthog';
import { fireProfessionalTypePopupViewed, fireProfessionalTypeSelected } from '~/posthogs/events';
import { SelectProfessionTypePopup } from '../SelectProfessionType/SelectProfessionTypePopup';
import { useSelectProfessionType } from '../SelectProfessionType/useSelectProfessionType';

interface IPostNewShiftsButtonProps {
  text?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
}

export const PostNewShiftsButton: FC<IPostNewShiftsButtonProps> = ({
  text = 'Post Shifts',
  disabled = false,
  style,
  textStyle,
}) => {
  const navigate = useNavigate();
  const user = useUserSelector();
  const officeState = user?.address?.[0]?.state ?? '';

  const shouldUseShiftRequestRedesign = useFeatureFlagVariant(ShiftRequestRedesign, 'test');

  const [isShowPopup, setIsShowPopup] = useState(false);

  const { availableProfessions } = useSelectProfessionType({ officeState });

  const handleClick = () => {
    trackPosthogEvent(POSTHOG_EVENTS.OFFICE_DASHBOARD_SHIFT_REQUEST_CLICKED);
    if (shouldUseShiftRequestRedesign) {
      fireProfessionalTypePopupViewed();
    }
    setIsShowPopup(true);
  };

  const handleContinue = (professionCode: string) => {
    if (shouldUseShiftRequestRedesign) {
      fireProfessionalTypeSelected();
    }
    setIsShowPopup(false);
    const target = shouldUseShiftRequestRedesign
      ? routes.selectDates
      : '/dashboard/multi-day/info';
    navigate(target, {
      state: { professionType: professionCode, inviteSource: 'Shift Request' },
    });
  };

  const handleClose = () => {
    setIsShowPopup(false);
  };

  return (
    <>
      <Button
        disabled={disabled}
        text={text}
        style={{ width: 206, marginTop: 0, ...style }}
        textStyle={textStyle}
        onClick={handleClick}
      />
      {isShowPopup && (
        <SelectProfessionTypePopup
          professions={availableProfessions}
          onContinue={handleContinue}
          onClose={handleClose}
        />
      )}
    </>
  );
};
